// extracted by mini-css-extract-plugin
module.exports = {"main-component":"timeUp_main-component__1re7j"};